<template>
  <div>
    <b-modal centered  id="ModalTableAssociateList" modal-class="custom-dialog dialog-900" hide-footer :title="modalTitle" @close="close" no-close-on-esc no-close-on-backdrop>
      <form-render :form.sync="form" :fields="fields" :key="keyFormRender"></form-render>
      <div class="d-flex justify-content-end">
        <b-button variant="outline-success" @click="downloadList" :disabled="loading.exportExcel" class="mt-1 mb-1">
          <feather-icon v-if="!loading.exportExcel" icon="DownloadIcon"/>
          <b-spinner v-if="loading.exportExcel" small type="border" variant="success" />
          Exportar lista
        </b-button>
      </div>
      <filter-swapper v-if="!loading.list && actionType() === 'future'" :trigger="selectedRows.length === 0" :buttons="buttons" :controlHeightButtons="controlHeight"></filter-swapper>
      <table-render v-if="!loading.list" :rows="rows" :schema="schema" responsive :showCheckboxes="true" :selectedRows.sync="selectedRows">
        <template #actionsRows="data">
          <div v-if="editingRow && editingRow.rowdata.id === data.rowdata.id" class="d-flex justify-content-center actions-rows">
            <b-button variant="none" size="sm" @click="saveEdit(data)" :disabled="loading.editAssociations">
              <feather-icon v-if="!loading.editAssociations" icon="CheckIcon" class="text-success" v-b-tooltip.hover title="Guardar cambios" />
              <b-spinner v-if="loading.editAssociations" small type="border" variant="success" class="ml-1" />
            </b-button>
            <b-button variant="none" size="sm" @click="cancelEdit(data)" :disabled="loading.editAssociations">
              <feather-icon icon="XIcon" class="text-danger" v-b-tooltip.hover title="Descartar cambios" />
            </b-button>
          </div>
          <div v-else class="d-flex justify-content-center actions-rows">
            <b-button variant="none" size="sm" @click="editRow(data)" :disabled="!!editingRow">
              <feather-icon icon="Edit2Icon" class="text-primary" v-b-tooltip.hover :title="actionType() === 'current' ? 'Editar fecha fin' : 'Editar fechas inicio / fin'" />
            </b-button>
            <b-button v-if="actionType() === 'future'" variant="none" size="sm" @click="confirmDeleteAssociation(data)" :disabled="loading.delete">
              <feather-icon v-if="!loading.delete" icon="TrashIcon" class="text-danger" v-b-tooltip.hover title="Eliminar Asociación" />
              <b-spinner v-if="loading.delete" small type="border" variant="danger" />
            </b-button>
          </div>
        </template>
        <template v-for="(currentSlot, index) in editedColumns" v-slot:[`${currentSlot}`]="data">
          <template v-if="currentSlot === 'validity_date'">
            <FieldDatepicker
              v-if="actionType() === 'future' && editingRow && editingRow.rowdata.id === data.rowdata.id"
              :key="index"
              :name="currentSlot"
              :value="getFormattedDate(data.rowdata[currentSlot])"
              :available-dates="{ start: new Date() }"
              @update:value="(newValue) => data.rowdata[currentSlot] = newValue"
            />
            <span v-else :key="index">{{ formatTimestamp(data.rowdata[currentSlot]) }}</span>
          </template>
          <template v-if="currentSlot === 'expiration_date'">
            <FieldDatepicker
              v-if="editingRow && editingRow.rowdata.id === data.rowdata.id"
              :key="index"
              :name="currentSlot"
              :value="getFormattedDate(data.rowdata[currentSlot])"
              :available-dates="{ start: data.rowdata.validity_date ? new Date(getFormattedDate(data.rowdata.validity_date)) : new Date() }"
              :clearable="true"
              @update:value="(newValue) => data.rowdata[currentSlot] = newValue ? newValue : null"
            />
            <span v-else :key="index">{{ formatTimestamp(data.rowdata[currentSlot]) }}</span>
          </template>
        </template>
      </table-render>
      <pagination :pagination="pagination" v-if="!loading.list"/>
      <div class="table-render-skeleton" v-if="loading.list"><b-skeleton-table :rows="3" :columns="(schema.length || 2)" /></div>
    </b-modal>
  </div>
</template>

<script>
import BaseServices from '@/store/services/index'
import FieldDatepicker from '@/views/components/custom/form-render/fields/FieldDatepicker.vue'
import dayjs from 'dayjs'

export default {
  name: 'ModalTableAssociateList',
  components: { FieldDatepicker },
  data() {
    return {
      baseService: new BaseServices(this),
      form: {},
      fields: [],
      keyFormRender: 0,
      loading: {
        list: true,
        delete: false,
        editAssociations: false,
        exportExcel: false
      },
      rows: [],
      editingRow: null,
      editedRow: null,
      schema: [],
      pagination: {
        page: 1,
        total: 0,
        limit: 10
      },
      selectedRows: [],
      buttons: [],
      controlHeight: { class: 'row mb-2 spacing-label-field' },
      paramPage: 1,
      paramPageSize: 10,
      editedColumns: ['validity_date', 'expiration_date'],
      modalTitle: ''
    }
  },
  props: {
    formTableList: {
      type: Object,
      required: true
    },
    closeModal: {
      type: Function
    }
  },
  watch: {
    'pagination.page'() {
      this.paramPage = this.pagination.page
      this.getAssociations()
    },
    'pagination.limit'() {
      this.paramPageSize = this.pagination.limit
      this.getAssociations()
    }
  },
  methods: {
    setInitialData() {
      this.actionType()
      this.initializeForm()
      this.initializeSchema()
      this.getAssociations()
      this.buttons = [
        { name: 'deleteAll', text: 'Eliminar', color: 'danger', icon: 'TrashIcon', action: () => this.confirmDeleteMultipleAssociations(), disabled: this.loading.delete }
      ]
      if (this.formTableList?.service) {
        this.form.service = this.formTableList.service
      }
      if (this.formTableList?.idSeller) {
        this.form.idSeller = this.formTableList.idSeller
      }
    },
    initializeForm() {
      this.form = this.formTableList
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'service', label: 'Servicio', change: this.changeService, containerClass: 'container-info col-sm-12 col-md-6 col-lg-6', sort: true, options: this.formTableList.servicesOptions },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'idSeller', label: 'Ecommerce/Marketplace', change: this.changeIdSeller, containerClass: 'container-info col-sm-12 col-md-6 col-lg-6', clearable: true, searchOnType: { fx: this.setSeller, nChars: 2, debounce: 600, allowSearchAsValue: false, persistSearch: true } }
      ]
    },
    initializeSchema() {
      this.schema = [
        { label: 'Servicio', key: 'carrier_service_name', class: 'text-left' },
        { label: 'Ecommerce/Marketplace - Id', key: 'company_name_id', class: 'text-left' },
        { label: 'Fecha Inicio', key: 'validity_date', useSlot: true },
        { label: 'Fecha Fin', key: 'expiration_date', useSlot: true, icon: 'InfoIcon', text: 'Vigencia hasta las 23:59 del día seleccionado. ' },
        { label: 'Acciones', key: 'actionsRows', class: ['text-center'], useSlot: true }
      ]
    },
    actionType() {
      if (this.formTableList?.actionType === 'current') {
        this.modalTitle = `Actual lista ${this.formTableList.row.name}`
        return 'current'
      } else if (this.formTableList?.actionType === 'future') {
        this.modalTitle = `Programada lista ${this.formTableList.row.name}`
        return 'future'
      } else if (this.formTableList?.actionType === 'delete') {
        this.modalTitle = `Eliminar Asociaciones de: ${this.formTableList.row.name}`
        return 'delete'
      }
    },
    getAssociations() {
      const params = {prices_list_id: this.formTableList.row.id}
      const queryParams = this.buildQueryParams()
      this.loading.list = true
      this.baseService
        .callService('getAssociations', queryParams, params)
        .then((resp) => {
          this.rows = resp.data.map(el => ({ ...el, company_name_id: `${el.company_name} - ${el.company_id}`, validity_date: el.validity_date || '', expiration_date: el.expiration_date || '' }))
          this.pagination.total = resp.meta?.total_rows || 0
          this.paramPage = resp.data.meta?.page || 1
          this.paramPageSize = resp.data.meta?.page_size || 10
        })
        .catch((err) => {
          this.$newError('Error', err.message, 'large')
        })
        .finally(() => {
          this.loading.list = false
        })
    },
    getFormattedDate(date) {
      return date ? dayjs(date).toDate() : null
    },
    changeService() {
      this.getAssociations()
      this.selectedRows = []

    },
    changeIdSeller() {
      this.getAssociations()
      this.selectedRows = []
    },
    confirmDeleteAssociation(val) {
      this.$yesno(this.$t('¿Está seguro de eliminar esta asociación?'), () => this.deleteAssociations({val}))
    },
    confirmDeleteMultipleAssociations() {
      const msgAllSelection = '¿Está seguro de eliminar todas las asociaciones?'
      const msgMultipleSelection = '¿Está seguro de eliminar las asociaciones selecionadas?'
      if (this.selectedRows.length === this.rows.length) {
        this.$yesno(this.$t(msgAllSelection), () => this.deleteAssociations({all: true}))
      } else {
        this.$yesno(this.$t(msgMultipleSelection), () => this.deleteAssociations(this.selectedRows))
      }
    },
    deleteAssociations(val) {
      this.loading.delete = true
      this.callDelete(val)
    },
    callDelete(value) {
      const data = {}
      if (value?.all) {
        data.delete_all = true
      } else {
        data.associations_ids = value?.val?.rowdata?.id ? [value?.val?.rowdata?.id] : this.selectedRows
      }
      if (this.form.idSeller && value?.all) {
        data.company_id = this.form.idSeller.id
        data.parent_company_id = this.form.idSeller.id
      }
      if (this.form.service && value.all) {
        data.carrier_service_id = this.form.service.id
      }
      this.baseService
        .callService('deleteAssociations', data, {price_list_id: this.formTableList.row.id})
        .then((resp) => {
          this.$newSuccess('Exito', resp.message)
          this.getAssociations()
        })
        .catch((err) => {
          this.$newError('Error', err.message, 'large')
          this.loading.delete = false
        })
        .finally(() => {
          this.loading.delete = false
          this.selectedRows = []
        })
    },
    async setSeller(value) {
      const params = {
        country_id: this.formTableList.country.id
      }
      const queryParams = {
        search: value
      }
      return await this.baseService
        .callService('getSeller', queryParams, params)
        .then((resp) => {
          return resp.data.organizations.map((el) => ({
            ...el,
            text: el.fullname,
            valid: true
          }))
        })
        .catch((err) => {
          return err
        })
    },
    buildQueryParams(val = {}) {
      const queryParams = {
        page: this.paramPage,
        page_size: this.paramPageSize
      }
      if (this.form.service?.id) queryParams.carrier_service_id = this.form.service.id
      if (this.form.idSeller?.id) queryParams.company_id = this.form.idSeller.id
      if (val?.all) queryParams.delete_all = true
      if (val?.id) queryParams.associations_ids = [val.id]
      if (this.actionType() === 'current') queryParams.validity_types = ['current']
      if (this.actionType() === 'future') queryParams.validity_types = ['future']
      if (!val?.all && !val?.id && this.selectedRows.length) {
        queryParams.associations_ids = this.selectedRows
      }
      return queryParams
    },
    cleanFilter() {
      delete this.form.idSeller
      delete this.form.service
      this.selectedRows = []
      this.getAssociations()
    },
    close() {
      this.editingRow = null
      this.editedRow = null
      this.$emit('closeModal', false)
      this.selectedRows = []
    },
    editRow(val) {
      this.editingRow = val // Activar el modo de edición para la fila seleccionada
      this.editedRow = JSON.parse(JSON.stringify(val.rowdata)) // Hacer una copia profunda de los datos originales
    },
    cancelEdit(val) {
      if (this.m_getElementIndex(this.rows, 'id', val.rowdata.id) !== -1) this.rows[this.m_getElementIndex(this.rows, 'id', val.rowdata.id)].expiration_date = this.editedRow.expiration_date
      if (this.m_getElementIndex(this.rows, 'id', val.rowdata.id) !== -1) this.rows[this.m_getElementIndex(this.rows, 'id', val.rowdata.id)].validity_date = this.editedRow.validity_date
      this.editingRow = null // Salir del modo de edición
      this.editedRow = null // Limpiar la copia temporal
    },
    saveEdit(val) {
      if (this.m_getElementIndex(this.rows, 'id', val.rowdata.id) !== -1) {
        if (val.rowdata.expiration_date) {
          this.rows[this.m_getElementIndex(this.rows, 'id', val.rowdata.id)] = val.rowdata.expiration_date
          this.editedRow.expiration_date = dayjs(val.rowdata.expiration_date).format('YYYY-MM-DD')
        } else {
          this.editedRow.expiration_date = null
        }
        if (val.rowdata.validity_date) {
          this.rows[this.m_getElementIndex(this.rows, 'id', val.rowdata.id)] = val.rowdata.validity_date
          this.editedRow.validity_date = dayjs(val.rowdata.validity_date).format('YYYY-MM-DD')
        }
      }
      const params = {
        association_id: val.rowdata.id
      }
      const data = {}
      data.expiration_date = this.editedRow?.expiration_date ? dayjs(this.editedRow.expiration_date).format('YYYY-MM-DD') : null
      if (this.editedRow?.validity_date) data.validity_date = dayjs(this.editedRow.validity_date).format('YYYY-MM-DD')
      this.putEditAssociations(params, data)
    },
    putEditAssociations(params, data) {
      this.loading.editAssociations = true
      this.baseService.callService('putEditAssociations', data, params)
        .then(() => {
          this.$newSuccess('Asociaciones editadas correctamente')
        })
        .catch(err => {
          this.$newError('Error', err.message, 'large')
        })
        .finally(() => {
          this.setInitialData()
          this.loading.editAssociations = false
          this.editingRow = null
          this.editedRow = null
        })
    },
    downloadList() {
      const params = {
        prices_list_id: this.formTableList.row.id,
        type_list: this.formTableList.actionType
      }
      this.loading.exportExcel = true
      const props = {
        name: 'exportAssociatePricesLists',
        fileName: `Lista de asociaciones ${this.formTableList.carrier?.name} - ${this.formTableList.row?.name}`,
        params,
        onSuccess: () => {
          this.loading.exportExcel = false
          this.$newSuccess('¡Descarga Ok!', 'El archivo ha sido descargado con éxito.')
        },
        onError: (err) => {
          this.loading.exportExcel = false
          this.$alert(this.$t('¡Error!, Ha ocurrido un error al descargar el archivo.', {code: err}))
        }
      }
      this.$store.dispatch('fetchServiceGenerateExcel', props)
    },
    formatTimestamp(timestamp, format) {
      if (timestamp) return dayjs(timestamp).format(format || 'DD/MM/YYYY')
      return '--'
    }
  }
}
</script>